import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class invitedBuyerSubEntiyRelationsCtrl {
    /* @ngInject */
    constructor(
        logger,
        $translate,
        uiGridExporterConstants,
        $uibModal,
        PrincipalSvc,
        InvBuyerSubEntityRelationFilter,
        KissSellerSvc,
        $window
    ) {
        this.logger = logger;
        this.$translate = $translate;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.$uibModal = $uibModal;
        this.PrincipalSvc = PrincipalSvc;
        this.InvBuyerSubEntityRelationFilter = InvBuyerSubEntityRelationFilter;
        this.KissSellerSvc = KissSellerSvc;
        this.$window = $window;
    }

    $onInit() {
        var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
        var erreurTemplate =
        '<div class="ui-grid-cell-contents"  style="text-align: center;">  <i ng-show="row.entity.hasFormError()"  class="fa fa-info-circle ui-grid-cursor-pointer text-center" aria-hidden="true" ng-click="grid.appScope.$ctrl.errorForm({subEntityCode : row.entity.subEntity.code},{subEntityId : row.entity.subEntity.id})"></i></div>'
        // ---------------
        // Data API
        // ---------------
        // Recherche
        this.principal = this.subEntity.legalEntity.principal;
        this.searchOpen = true;
        this.searchData = new this.InvBuyerSubEntityRelationFilter();
        this.hasCooperative = this.relations.some(relation => 
            (relation.cooperativeName != null && relation.cooperativeName != undefined));
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'subEntity.legalEntity.countryCode',
                    displayName: 'subInvited_entity_relation.list.country',
                    headerCellFilter: 'translate',
                    width: '50',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'getLegalEntityIdentifiant()',
                    displayName: 'subInvited_entity_relation.list.buyer_legalEntity_identifier',
                    headerCellFilter: 'translate',
                    width: '180',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'subEntity.legalEntity.name',
                    displayName: 'subInvited_entity_relation.list.buyer_name',
                    headerCellFilter: 'translate',
                    width: '180',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'getLegalEntityStatus()',
                    displayName: 'subInvited_entity_relation.list.buyer_legalEntity_statut',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'subEntity.code',
                    displayName: 'subInvited_entity_relation.list.buyer_subEntity_identifier',
                    headerCellFilter: 'translate',
                    width: '140',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'subEntity.name',
                    displayName: 'subInvited_entity_relation.list.buyer_subEntity_name',
                    headerCellFilter: 'translate',
                    width: '180',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'getSubEntityStatus()',
                    displayName: 'subInvited_entity_relation.list.buyer_subEntity_statut',
                    headerCellFilter: 'translate',
                    width: '100',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'dateAcceptationForm()',
                    displayName: 'subInvited_entity_relation.list.acceptation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'dateEndOfValidityForm()',
                    displayName: 'subInvited_entity_relation.list.end_validity',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'codeErp',
                    displayName: 'subInvited_entity_relation.list.code_ERP',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'cooperativeName',
                    displayName: 'subInvited_entity_relation.list.cooperative',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'hasFormError()',
                    displayName: 'subInvited_entity_relation.list.erreur',
                    headerCellFilter: 'translate',
                    cellTemplate: erreurTemplate ,
                },

            ],
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            onRegisterApi: gridApi => (this.gridApi = gridApi),
            enableSorting: true,
            enableGridMenu: false,
            data: this.relations,
            enableColumnMenus: false,
        };
        this.gridOptions.columnDefs[10].visible = this.hasCooperative;
    }

    searchRelatedLegalEntities(value) {
        if (value && value.length >= 3) {
            return this.KissSellerSvc.searchRelatedLegalEntities(value, this.subEntity.id).then(legalEntity => {
                return legalEntity;
            });
        }
    }

    searchRelatedSubEntities(value) {
        if (value && value.length >= 3) {
            return this.KissSellerSvc.searchRelatedSubEntities(value, this.subEntity.id).then(subEntity => {
                return subEntity;
            });
        }
    }

    search() {
        this.KissSellerSvc.getSubEntityRelations(this.subEntity.id, this.searchData).then(
            relations => {
                this.gridOptions.data = relations;
            },
            () => {
                this.logger.error('error.search');
            }
        );
    }

    clearForm() {
        // Reset data
        this.searchData = new this.InvBuyerSubEntityRelationFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }
    errorForm(subEntityCode,subEntityId){
        this.PrincipalSvc.getSubEntityRejectionInfo(subEntityId.subEntityId).then(
        data => {
        this.$uibModal.open({
            component: 'errorModal',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            resolve: {
            modalMessage: () => {
                return {
                    data: data,
                    subEntityCode:subEntityCode.subEntityCode,
                };
            }
        }
        }).result.then(
            () =>{} ,
            () => {}
        )},
        () => {});

    }

    emptyData() {
        if(this.gridOptions.data && this.gridOptions.data.length>0) {
            return false;
        }
        return true;
    }
    exportCsv() {
        this.gridOptions.exporterCsvFilename = 'relationsEtablissementsDOClient-' + this.subEntity.code +'-'+ moment().format('DDMMYYYYHHmmSS') + '.csv';
        this.gridOptions.exporterHeaderFilter = this.$translate.instant;
        this.gridOptions.exporterSuppressColumns = ['detail'];
        this.gridApi.exporter.csvExport(this.uiGridExporterConstants.VISIBLE, this.uiGridExporterConstants.VISIBLE);
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    back() {
        this.$window.history.back();
    }

    /**
     * Vérifie le type du subEntity
     */
    checkKindSubEntity(){
        return this.subEntity.kind === "ESTABLISHMENT";
    }
}

angular.module('app.principal').component('invBuyerSubEntityRelations', {
    templateUrl: require('./invited-buyer-sub-entity-relations.html'),
    controller: invitedBuyerSubEntiyRelationsCtrl,
    bindings: {
        subEntity: '<',
        relations: '<',
        countries: '<',
    },
});
